<script lang="ts" setup>
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { ref, computed } from 'vue';
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { AllBusinessesForSupplierForecastStore } from '../pages/useAllBusinessesForSupplierForecastStore';
import { storeToRefs } from 'pinia';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';

// props
const props = withDefaults(
  defineProps<{
    indexOfSelectInput?: number; // SelectInputの排他制御で、現在の画面で使ってるSelectInputのindexが被ってはいけないので、indexを渡す
    store: AllBusinessesForSupplierForecastStore;
  }>(),
  {
    indexOfSelectInput: 1,
  }
);

//変数
const t = i18n.t;

const isOpenSelectInput = ref(false);

const { state } = storeToRefs(props.store);

const modalState = computed({
  /**
   * getter
   */
  get: () => {
    return state.value.editForecastModalState.modalState;
  },
  /**
   * setter
   * @param value - value
   */
  set: (value) => {
    state.value.editForecastModalState.modalState = value;
  },
});
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('適用')"
    :modal-width="764"
    :is-disabled-next-button="store.isDisabledApplyEditButton"
    @on-back="modalState = false"
    @on-next="store.onApplyEdit"
  >
    <template #title>{{ t('仕入先内示:編集') }}</template>
    <template #description>
      {{ t('チェックが付いている選択済の内示に対して、担当者名とキーワードを一括適用で修正できます。') }}
    </template>
    <div class="edit-modal-content__main-content main-content">
      <div class="main-content__container">
        <div class="main-content__change-basic-info">
          <div class="main-content__select-input-content select-input-content">
            <MultipleUserSelectInput
              :select-input-index="indexOfSelectInput"
              @update:model-value="state.editForecastModalState.selectedStaffIdList = $event"
            />
          </div>
        </div>
        <!-- 202509 現在未実装のためOmit -->
        <div class="main-content__change-keyword-container change-keyword-container">
          <!--
          <div class="change-keyword-container__content-container">
            <div class="change-keyword-container__title">
              {{ t('キーワードを選択') }}
            </div>
            <div class="change-keyword-container__mock1" />
          </div>
          <div class="change-keyword-container__content-container">
            <div class="change-keyword-container__title">
              {{ t('キーワードを新規追加') }}
            </div>
            <div class="change-keyword-container__mock2" />
          </div>
          -->
        </div>
      </div>
    </div>
  </InfoModal>
</template>

<style lang="scss" scoped>
.main-content {
  background-color: $backgroundDefault;
  border-radius: 8px;

  &__container {
    height: 100%;
    width: 100%;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 16px;
    align-content: space-between;
  }

  &__change-basic-info {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 16px;
    justify-content: start;
  }

  &__select-input-content {
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 8px;
  }

  &__change-keyword-container {
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 16px;
  }

  .select-input-content {
    &__title {
      font-size: 14px;
      line-height: 14px;
      font-weight: 400;
      color: $textDefault;
    }

    &__select-input {
      width: 160px;
      height: 32px;
    }
  }

  .change-keyword-container {
    &__content-container {
      display: grid;
      grid-template-rows: repeat(2, auto);
      gap: 8px;
    }

    &__title {
      font-size: 14px;
      line-height: 14px;
      font-weight: 400;
      color: $textDefault;
    }

    &__mock1 {
      height: 56px;
    }
    &__mock2 {
      height: 34px;
    }
  }
}
</style>
